export type StandingsViewEntry = {
  userId: string;
  userName: string;
  wins: number;
  losses: number;
  pointsFor: number;
  pointsAgainst: number;
  pointDifferential: number;
  matchesPlayed: number;
  isCurrentUser?: boolean;
};

export class StandingsView {
  private root?: HTMLDivElement;

  public mount(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'tourney-standings-viewport';
    parent.appendChild(this.root);
  }

  public render(entries: StandingsViewEntry[], totalMatches: number, currentUserId?: string) {
    if (!this.root) return;
    const completedMatches = entries.length
      ? entries.reduce((sum, entry) => sum + entry.matchesPlayed, 0) / 2
      : 0;
    const html = `
      <div class="tourney-standings-container">
        <div class="tourney-standings-header">
          <div class="tourney-standings-title">Standings</div>
          <div class="tourney-standings-subtitle">
            ${completedMatches} of ${totalMatches} matches completed
          </div>
        </div>

        <table class="tourney-standings-table">
          <thead>
            <tr>
              <th>Player</th>
              <th>W-L</th>
              <th>PF</th>
              <th>PA</th>
              <th>Diff</th>
            </tr>
          </thead>
          <tbody>
            ${entries.map(entry => `
              <tr class="tourney-standings-row ${entry.userId === currentUserId ? 'current-user' : ''}">
                <td class="name-col">${entry.userName}</td>
                <td class="record-col">${entry.wins}-${entry.losses}</td>
                <td class="pf-col">${entry.pointsFor}</td>
                <td class="pa-col">${entry.pointsAgainst}</td>
                <td class="diff-col ${entry.pointDifferential >= 0 ? 'positive' : 'negative'}">
                  ${entry.pointDifferential >= 0 ? '+' : ''}${entry.pointDifferential}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        
      </div>
    `;
    this.root.innerHTML = html;
  }

  public destroy() {
    if (this.root?.parentElement) {
      this.root.parentElement.removeChild(this.root);
    }
    this.root = undefined;
  }
}
